<template>
  <div>
    <!-- ---头部--- -->
    <content-title title="补充数据表-烧碱"/>
    <action-btn v-if="editOrView==='edit'" :btnLoading="btnLoading" @synchronousData="synchronousData"
                @co2Data="co2Data" @calcu="calcu"/>
    <Table
        :disabled-hover="true"
        :columns="columns14"
        :data="data5"
        border
        :loading="btnLoading.tableLoading"
        :span-method="SpanCellMerge">
      <template v-for="(item,index) in titles" slot-scope="{row}" :slot="'item'+index">
        <div v-if="editOrView==='edit'">
          <Input
              v-if="row.lineNames "
              type="number"
              v-model="row.itemVals[index]"
              :key="index"
              v-selfDecimal="{row}"
              v-selfcalcu="{row}"
              @on-blur="changeData(row)"
          />
          <Input v-else-if="!row.lineNames && !displayKey.includes(row.itemName)" v-selfDecimal="{row}" type="number"
                 v-model="row.itemVal" :key="index"
                 @on-blur="changeData(row)"/>
        </div>
        <div v-else :key="index">
          <span v-if="row.lineNames && row.itemVals[index]!=='-'">{{ row.itemVals[index] }}</span>
          <span v-else-if="!row.lineNames">{{ row.itemVal }}</span>
        </div>
      </template>
    </Table>

    <!-- ---底部按钮组--- -->
    <save-next v-if="editOrView == 'edit'" :btnLoading="btnLoading" @on-save="save('save')" @go-next="nextPage"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import contentTitle from "@/components/comment/content-title.vue";
import actionBtn from './component/ActionBtn'
import saveNext from "@/components/comment/save-next.vue";
import {owenFiexd} from '@/directive'
import {
  getCausticSodaSupplementaryData,
  causticSodaSupplementaryAutomaticCalc,
  syncCausticSodaSupplementary
} from '@/api/emissions-report'

export default {
  directives: {
    selfDecimal: {
      bind(el, binding) {
        let row = binding.value.row
        const input = el.getElementsByTagName('input')[0]
        input.onfocus = function (e) {
          if (Number(input.value) === 0) {
            input.value = ''
          }
        }
        input.onblur = function (e) {
          let num2 = ['二氧化碳排放量（tCO₂）', '消耗电力对应的排放量（tCO₂）', '≥30%烧碱生产产生的排放量（tCO₂）',
            '≥30%烧碱生产电力消耗产生的排放量（tCO₂）', '≥30%烧碱生产热力消耗对应的排放量（tCO₂）', '≥45%烧碱生产产生的排放量（tCO₂）',
            '≥45%烧碱生产电力消耗产生的排放量（tCO₂）', '≥45%烧碱生产热力消耗对应的排放量（tCO₂）', '片碱生产产生的排放量（tCO₂）',
            '化石燃料燃烧排放量（tCO₂）', '片碱生产电力消耗对应的排放量（tCO₂）', '片碱生产热力消耗对应的排放量（tCO₂）', '消耗电量（MWh）']
          let num4 = ['片碱热力供应排放因子（tCO₂/GJ）', '片碱电力供应排放因子（tCO₂/MWh）', '≥45%烧碱热力供应排放因子（tCO₂/GJ）', '≥45%烧碱电力供应排放因子（tCO₂/MWh）','对应的排放因子（tCO₂/MWh）', '≥30%烧碱电力供应排放因子（tCO₂/MWh）', '≥30%烧碱热力供应排放因子（tCO₂/GJ）']
          if (num2.includes(row.itemName)) {
            input.value = owenFiexd(input.value, 2)
          }
          if (num4.includes(row.itemName)) {
            input.value = owenFiexd(input.value, 4)
          }
        }
      }
    },
    selfcalcu: {
      bind: function (el, binding) {
        let row = binding.value.row
        let calcuOptions = ['二氧化碳排放量（tCO₂）', '消耗电力对应的排放量（tCO₂）', '≥30%烧碱生产产生的排放量（tCO₂）',
          '≥30%烧碱生产电力消耗产生的排放量（tCO₂）', '≥30%烧碱生产热力消耗对应的排放量（tCO₂）', '≥45%烧碱生产产生的排放量（tCO₂）',
          '≥45%烧碱生产电力消耗产生的排放量（tCO₂）', '≥45%烧碱生产热力消耗对应的排放量（tCO₂）', '片碱生产产生的排放量（tCO₂）',
          '化石燃料燃烧排放量（tCO₂）', '片碱生产电力消耗对应的排放量（tCO₂）', '片碱生产热力消耗对应的排放量（tCO₂）', '消耗电量（MWh）']
        if (calcuOptions.includes(row.itemName)) {
          let className = el.getAttribute("class")
          className = className.concat(" input-call")
          el.setAttribute("class", className)
        }
      }
    }
  },
  components: {
    contentTitle,
    saveNext,
    actionBtn
  },
  computed: {
    ...mapGetters(['getUserInfo', 'getMenu']),
    editOrView() {
      return this.getUserInfo.user.editOrView;
    },
    reportId() {
      return this.getUserInfo.user.reportId;
    },
    companyId() {
      return this.getUserInfo.user.companyId;
    },
    menu() {
      return this.getMenu
    }
  },
  data() {
    return {
      // 合并行/列
      merge1: [],
      pos1: 0,
      tempKeyStr: ['≥30%烧碱生产产生的排放量（tCO₂）', '≥45%烧碱生产产生的排放量（tCO₂）', '片碱生产产生的排放量（tCO₂）'],
      displayKey: ['按烧碱产品生产工序分类的排放情况', '≥30%烧碱', '≥45%烧碱', '片碱'],
      btnLoading: {
        saveUnit: false,
        nextPage: false,
        synchronousData: false,
        calcu: false,
        co2Data: false,
        tableLoading: false
      },
      columns14: [
        {
          title: "补充数据",
          fixed: "left",
          children: [
            {key: "infoName", align: "center", fixed: "left",},
            {key: "itemName", align: "center", fixed: "left",},
          ],
        },
      ],
      data5: [],
      titles: [],
      resData: [],
    };
  },
  created() {
    this.getList()
  },
  methods: {
    dataDecimal(data, number) {
      data.itemVals.forEach((item, index) => {
        if (data.itemVals[index] !== '-') {
          data.itemVals[index] = owenFiexd(item, number)
        }
      })
    },
    async getList() {
      let params = {
        reportId: this.reportId
      }
      let tempIndex = []
      this.btnLoading.tableLoading = true
      await getCausticSodaSupplementaryData(params).then(res => {
        this.titles = res.body.allLineNameList
        res.body.menuList.forEach((item, index) => {

          // 确定展示字段所需索引
          if (this.tempKeyStr.includes(item.itemName)) {
            tempIndex.push(index)
          }

          if (item.lineName) {
            item.infoName = item.lineName
          } else {
            let num2 = ['二氧化碳排放量（tCO₂）', '消耗电力对应的排放量（tCO₂）', '≥30%烧碱生产产生的排放量（tCO₂）',
              '≥30%烧碱生产电力消耗产生的排放量（tCO₂）', '≥30%烧碱生产热力消耗对应的排放量（tCO₂）', '≥45%烧碱生产产生的排放量（tCO₂）',
              '≥45%烧碱生产电力消耗产生的排放量（tCO₂）', '≥45%烧碱生产热力消耗对应的排放量（tCO₂）', '片碱生产产生的排放量（tCO₂）',
              '化石燃料燃烧排放量（tCO₂）', '片碱生产电力消耗对应的排放量（tCO₂）', '片碱生产热力消耗对应的排放量（tCO₂）', '消耗电量（MWh）']
            let num4 = ['片碱热力供应排放因子（tCO₂/GJ）', '片碱电力供应排放因子（tCO₂/MWh）', '≥45%烧碱热力供应排放因子（tCO₂/GJ）', '≥45%烧碱电力供应排放因子（tCO₂/MWh）', '对应的排放因子（tCO₂/MWh）', '≥30%烧碱电力供应排放因子（tCO₂/MWh）', '≥30%烧碱热力供应排放因子（tCO₂/GJ）']
            if (num2.includes(item.itemName)) {
              this.dataDecimal(item, 2)
            }
            if (num4.includes(item.itemName)) {
              this.dataDecimal(item, 4)
            }
          }
        })
        this.columns14.splice(1, this.columns14.length - 1)
        this.titles.forEach((item, index) => {
          this.columns14.push({
            title: item,
            slot: 'item' + index,
            width: this.titles.length > 5 ? 120 : ''
          })
        })
        res.body.menuList.splice(tempIndex[2], 0, {
          infoName: '片碱',
          itemName: '片碱',
          itemVal: '-',
          lineName: '片碱'
        })
        res.body.menuList.splice(tempIndex[1], 0, {
              infoName: '≥45%烧碱',
              itemName: '≥45%烧碱',
              itemVal: '-',
              lineName: '≥45%烧碱'
            }
        )
        res.body.menuList.splice(tempIndex[0], 0,
            {
              infoName: '按烧碱产品生产工序分类的排放情况',
              itemName: '按烧碱产品生产工序分类的排放情况',
              itemVal: '-',
              lineName: '按烧碱产品生产工序分类的排放情况'
            },
            {
              infoName: '≥30%烧碱',
              itemName: '≥30%烧碱',
              itemVal: '-',
              lineName: '≥30%烧碱'
            }
        )
        this.resData = JSON.parse(JSON.stringify(res.body.menuList))
        res.body.menuList.forEach(item => {
          if (!item.lineName) {
            item.infoName = item.itemName
          }
        })
        this.data5 = res.body.menuList
        this.getSpanArr(this.data5, 'infoName')
        this.btnLoading.tableLoading = false
      })
    },
    // 数据变动
    changeData(row) {
      let index = row['_index']
      let data = JSON.parse(JSON.stringify(row))
      data.infoName = this.resData[index].infoName
      delete data['_index']
      delete data['_rowKey']
      this.resData[index] = data
    },
    // 二氧化碳排放量同自动计算
    co2Data() {
      this.btnLoading.co2Data = true
      this.save('co2')
    },
    // 自动计算
    calcu() {
      this.btnLoading.calcu = true
      this.save('caclu')
    },
    async synchronousData() {
      this.btnLoading.synchronousData = true
      this.btnLoading.tableLoading = true
      let params = {reportId: this.reportId}
      await syncCausticSodaSupplementary(params).then(async res => {
        if (res.status === 200) {
          await this.getList()
          this.btnLoading.synchronousData = false
          this.$Message.success('同步成功')
        }
      })
    },
    // 保存
    async save(type, path) {
      let params = {reportId: this.reportId}
      if (type === 'save') {
        params.operateType = 'N'
        this.btnLoading.saveUnit = true
      } else if (type === 'next') {
        params.operateType = 'N'
        this.btnLoading.nextPage = true
      } else if (type === 'caclu') {
        params.operateType = 'Y'
      } else if (type === 'co2') {
        params.operateType = 'C'
      }
      let tempData = []
      this.getDataList(tempData)
      params.dataList = tempData
      this.btnLoading.tableLoading = true
      await causticSodaSupplementaryAutomaticCalc(params).then(async res => {
        if (res.status === 200) {
          if (type === 'save') {
            await this.getList()
            this.$Message.success('保存成功')
            this.btnLoading.saveUnit = false
          } else if (type === 'next') {
            await this.$router.push({path: path})
          } else if (type === 'caclu' || type === 'co2') {
            await this.getList()
            this.$Message.success('计算成功')
            this.btnLoading.calcu = false
            this.btnLoading.co2Data = false
          }
        }
      })
    },

    getDataList(tempData) {
      this.resData.forEach((item) => {
        if (!item.lineName) {
          item.itemVals.forEach((_item, index) => {
            let tempItem = JSON.parse(JSON.stringify(item))
            delete tempItem.ids
            delete tempItem.itemVals
            delete tempItem.lineNames
            tempItem.id = item.ids[index]
            tempItem.itemVal = _item
            tempItem.lineName = item.lineNames[index]
            if (tempItem.id) {
              tempData.push(tempItem)
            }
          })
        } else {
          let tempItem = JSON.parse(JSON.stringify(item))
          if (!this.displayKey.includes(tempItem.infoName)) {
            tempItem.infoName = ''
            tempData.push(tempItem)
          }
        }
      })
      return tempData
    },

    nextPage() {
      let path = this.$route.path
      let leavePath = ''
      let menu = this.menu[1].children
      for (let i = 0; i < menu.length; i++) {
        if (menu[i].path === path) {
          leavePath = menu[i + 1].path
          break
        }
      }
      this.save('next', leavePath)
    },
    // 合并列表
    getSpanArr(data, key1, key2) {
      let num = 0;
      if (key2 == undefined) {
        num = 1;
      } else {
        num = 2;
      }
      this[`merge${num}`] = [];
      this[`pos${num}`] = "";
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          this[`merge${num}`].push(1);
          this[`pos${num}`] = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          //根据相同key进行合并,根据需要可进行修改
          let temp;
          if (key2 != undefined) {
            temp = data[i][key2] === data[i - 1][key2] && data[i][key1] === data[i - 1][key1];
          }
          if (key2 == undefined) {
            temp = data[i][key1] === data[i - 1][key1];
          }
          if (temp) {
            this[`merge${num}`][this[`pos${num}`]] += 1;
            this[`merge${num}`].push(0);
          } else {
            this[`merge${num}`].push(1);
            this[`pos${num}`] = i;
          }
        }
      }
    },
    SpanCellMerge({row, column, rowIndex, columnIndex}) {
      if (columnIndex === 0 && row.itemName !== row.infoName) {
        const _row = this.merge1[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      } else if (columnIndex === 0 && row.itemName === row.infoName) {
        return {
          rowspan: 1,
          colspan: 2,
        };
      } else if (columnIndex === 1 && row.infoName === row.itemName) {
        return {
          rowspan: 0,
          colspan: 0,
        };
      } else if (columnIndex === 2) {
        if (row.lineName) {
          return [1, this.titles.length];
        }
      } else if (columnIndex !== 0 && columnIndex !== 1 && columnIndex !== 2 && row.itemName !== row.infoName) {
        if (row.lineName) {
          return [0, 0];
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.hello {
  width: 90%;
  margin: 0 auto 30px;
}
</style>
